export enum reportNames {
    averageFieldVisitsByRep = 'Average Field visits by Rep',
    fieldVisitHistoryByRep = 'Field Visit History by Rep',
    fieldVisitHistoryByTerri = 'Field Visit History by Territory',
    accountVisitStatus = 'Account Visit Status'
};
